export default "__VITE_ASSET__Bfd2b2F4__"